import { NgClass } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	input,
	output,
	ViewEncapsulation,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { MarkdownComponent } from 'ngx-markdown';

import { SelectionCardInterface } from '../selection-card.interface';

@Component({
	selector: 'vp-selection-card-input',
	imports: [MarkdownComponent, NgClass, SvgIconComponent, TranslatePipe],
	templateUrl: './selection-card-input.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SelectionCardInputComponent {
	controlType = input<'radio' | 'checkbox'>('radio');
	hasCardsAsMarkdown = input<boolean>(false);
	hasError = input<boolean>(false);
	isDisabled = input<boolean>(false);
	isReadonly = input<boolean>(false);
	isSelected = input<boolean>(false);
	isValid = input<boolean>(false);
	name = input<string>('');
	option = input.required<SelectionCardInterface>();

	changed = output<string>();

	changedValue(id: string): void {
		this.changed.emit(id);
	}
}
